// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__16ZpL","menubutton":"App_menubutton__3apdH","Button":"App_Button__3SFOE"};